import type { Action } from '~/actions'
import type { API } from '~/types'
import { defaultMarketConfig } from '~/utils/countryList'

export function shippingSettings(state: API.ShippingSetting[] = [], action: Action): API.ShippingSetting[] {
	switch (action.type) {
		case 'SHIPPING_SETTINGS_LOAD_SUCCESS':
			return action.payload
		default:
			return state
	}
}

export function markets(
	state: API.MarketConfig[] | null = defaultMarketConfig,
	action: Action
): API.MarketConfig[] | null {
	switch (action.type) {
		case 'MARKETS_LOAD_SUCCESS':
			return action.payload
		default:
			return state
	}
}
